import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { PageHeader, Loading } from "@/components/common";
import { PermMatrix } from "@/components/PermMatrix";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";

const FIELDS = [
  ["app_name", "Nama Aplikasi", "text"],
  ["default_reserve_pct", "Default Cadangan Estimasi (%)", "number"],
  ["default_round_multiple", "Default Pembulatan Invoice (kelipatan)", "number"],
  ["default_notas_per_page", "Default Nota per Halaman A4", "number"],
];

export default function AdminSettings() {
  const [f, setF] = useState(null);
  const { reload } = useAuth();
  useEffect(() => {
    api.get("/admin/settings").then((r) => setF(r.data)).catch((e) => toast.error(errMsg(e)));
  }, []);
  const save = async (e) => {
    e.preventDefault();
    try {
      const body = Object.fromEntries(FIELDS.map(([k, , t]) => [k, t === "number" ? Number(f[k]) : f[k]]));
      setF((await api.put("/admin/settings", body)).data);
      toast.success("Pengaturan aplikasi disimpan");
      reload();
    } catch (err) { toast.error(errMsg(err)); }
  };
  return (
    <div>
      <PageHeader sheet="ADMIN 05" title="Pengaturan Aplikasi" subtitle="Nama aplikasi platform (tampil di halaman login, sidebar, judul tab), nilai default perusahaan baru, dan hak akses lintas perusahaan." />
      {!f ? <Loading /> : (
        <form onSubmit={save} className="bg-white border border-slate-300 rounded-sm p-5 max-w-xl space-y-4" data-testid="admin-settings-form">
          {FIELDS.map(([k, l, t]) => (
            <div key={k}><Label className="text-xs font-semibold">{l}</Label><Input type={t} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} className="mt-1" data-testid={`admin-setting-${k}`} /></div>
          ))}
          <Button type="submit" className="bg-emerald-700 hover:bg-emerald-800" data-testid="admin-settings-submit">Simpan</Button>
        </form>
      )}
      <h2 className="font-display font-semibold text-lg mt-8 mb-2">Hak Akses Supervisor & Petugas Penarikan</h2>
      <PermMatrix url="/admin/platform-perms" />
    </div>
  );
}
